const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyUpdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Border_box",
    "data-name": "Border box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Full_path",
    "data-name": "Full path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "note",
    d: "M23.36,2.74l-2.99-1.72c-.06-.03-.12-.05-.19-.05h0s-1.34,0-1.34,0c-.28,0-.5.22-.5.5v14.41c-1.04-.6-2.4-.85-3.83-.6-2.74.49-4.65,2.64-4.28,4.79.37,2.15,2.89,3.5,5.63,3.01,2.54-.46,4.34-2.34,4.3-4.32h.02V4.04l1.82,1.05c.24.14.54.06.68-.18l.85-1.48c.14-.24.06-.54-.18-.68Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_down",
    "data-name": "arrow down",
    d: "M8.97,18.51h-2.13s0-3.91,0-3.91h-3.53v3.91H1.2c-.2.19-.2.51,0,.71l3.54,3.54c.2.2.51.2.71,0l3.54-3.54c.2-.2.2-.51,0-.71Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_up",
    "data-name": "arrow up",
    d: "M8.97,8.89l-3.54-3.54c-.2-.2-.51-.2-.71,0l-3.54,3.54c-.2.2-.2.51,0,.71h2.13s0,3.92,0,3.92h3.53v-3.92h2.13c.2-.19.2-.51,0-.71Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyUpdown);
export default __webpack_public_path__ + "static/media/key-updown.329fc08aeca1027445819a9560ffb87f.svg";
export { ForwardRef as ReactComponent };